import React from 'react';
import Header from '../../CoreFile/Header';
import Footer from '../../CoreFile/Footer';
import { TermsHeroSection } from './TermsHeroSection';

export const Terms = () => {
  return (
    <>
      <Header />
      <TermsHeroSection />

      <div className="bg-gray-50 text-gray-900 px-4 py-12">
        <div className="max-w-6xl mx-auto">
          <h1 className="text-4xl font-bold mb-6 text-center text-blue-600">
            Terms & Conditions
          </h1>
          <p className="text-center max-w-3xl mx-auto text-lg mb-12">
            Welcome to Glod Fox Market — your trusted destination for automated trading.
            By accessing or using our platform, you agree to abide by the following terms
            designed to ensure a safe, intelligent, and transparent trading experience.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Automated Trading Section */}
            <div className="p-6 bg-white rounded-2xl shadow-md border border-gray-200">
              <h2 className="text-xl font-semibold text-indigo-600 mb-4">
                🤖 Automated Trading & Algorithms
              </h2>
              <ul className="space-y-3">
                <li>✅ All trades executed by our bots are based on predefined logic and market indicators.</li>
                <li>✅ Users must monitor their bot settings and risk preferences regularly.</li>
                <li>✅ Glod Fox Market does not guarantee specific outcomes or profits from automated strategies.</li>
                <li>✅ Sudden market changes can affect bot performance. Users are advised to stay informed.</li>
              </ul>
            </div>

            {/* Account & Access */}
            <div className="p-6 bg-white rounded-2xl shadow-md border border-gray-200">
              <h2 className="text-xl font-semibold text-indigo-600 mb-4">
                🔐 Account Access & Security
              </h2>
              <ul className="space-y-3">
                <li>✅ Keep your login credentials confidential at all times.</li>
                <li>✅ Enable 2FA to secure your account against unauthorized access.</li>
                <li>✅ Report suspicious activity immediately to our support team.</li>
                <li>✅ Glod Fox will never ask for your password — stay alert to phishing scams.</li>
              </ul>
            </div>

            {/* Fair Usage & Compliance */}
            <div className="p-6 bg-white rounded-2xl shadow-md border border-gray-200">
              <h2 className="text-xl font-semibold text-indigo-600 mb-4">
                ⚖️ Fair Usage & Legal Compliance
              </h2>
              <ul className="space-y-3">
                <li>✅ Users must comply with local regulations and trading laws in their country.</li>
                <li>✅ Bots must not be used for illegal activities or market manipulation.</li>
                <li>✅ Glod Fox Market reserves the right to suspend accounts violating terms.</li>
              </ul>
            </div>

            {/* Liability & Risk Disclosure */}
            <div className="p-6 bg-white rounded-2xl shadow-md border border-gray-200">
              <h2 className="text-xl font-semibold text-indigo-600 mb-4">
                📉 Risk Disclaimer & Liability
              </h2>
              <ul className="space-y-3">
                <li>✅ Trading involves risk. You may lose part or all of your capital.</li>
                <li>✅ GFM is not liable for financial losses due to market volatility or technical issues.</li>
                <li>✅ Users are solely responsible for their trading decisions and bot configurations.</li>
              </ul>
            </div>
          </div>

          <div className="mt-12 text-center">
            <p className="text-base text-gray-700">
              By continuing to use Glod Fox Market, you confirm that you understand and accept
              these terms. Always trade smart and stay informed.
            </p>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};
